export enum SettingsCategory {
  ACCOUNT = 'account',
  WORKSPACE = 'workspace',
  PROJECT = 'project',
}
